const styles = theme => ({
  root: {
    position: 'relative',
    display: 'block',
    margin: [0, 'auto', 10],
    width: '100%'
  },
  svg: {
    display: 'block',
    position: 'absolute',
    left: 0,
    top: 0
  },
  path: {
    opacity: ({ energy }) => energy.animate ? 0 : 1
  },
  content: {
    position: 'relative',
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    margin: [0, 'auto'],
    padding: [16, 12, 8],
    width: '100%',
    maxWidth: 1180
  },
  brand: {
    margin: 0,
    width: 'auto',
    maxWidth: 'none',
    flex: '0 0 auto'
  },
  menu: {
    width: 'auto',
    flex: '0 0 auto'
  },

  '@media screen and (min-width: 768px)': {
    root: {
      marginBottom: 12
    },
    content: {
      flexDirection: 'column',
      flexWrap: 'nowrap',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 4,
      padding: [12, 8, 8]
    },
    brand: {
      margin: 0
    },
    menu: {
      margin: 0,
      maxWidth: 'none'
    }
  }
});

export { styles };
